export default "__VITE_ASSET__DKXON5Wu__"